<!-- 
Expand / collapse icon.
-->
<template>
  <v-icon :class="'expand-icon ' + (expanded ? 'expanded' : '')">expand_more</v-icon>
</template>

<script>
export default {
  props: {
    expanded: {
      type: Boolean,
      default: false
    }
  }
};
</script>
